export default "__VITE_ASSET__BUDFHeXb__"